export default "__VITE_ASSET__CYqLLoz8__"